import React, { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import Tabs, { TabPane } from "rc-tabs";
import { SolidosData as SolidosDataCostoMP } from "./ComparativoCostoMP/Data/SolidosData";
import { LatexData as LatexDataCostoMP } from "./ComparativoCostoMP/Data/LatexData";
import { SKIMData as SKIMDataCostoMP } from "./ComparativoCostoMP/Data/SKIMData";
import { SolidosData as SolidosDataCostoVentas } from "./ComparativoCostoVentas/Data/SolidosData";
import { LatexProcesoData } from "./ComparativoCostoVentas/Data/LatexProcesoData";

import { SKIMData as SKIMDataCostoVentas } from "./ComparativoCostoVentas/Data/SKIMData";
import ComparativoCostoMP from "./ComparativoCostoMP/ComparativoCostoMP";
import CardEmpty from "../../../../Utils/Cards/CardEmpty"
import ComparativoCostoVentas from "./ComparativoCostoVentas/ComparativoCostoVentas";
import { useApi } from "../Hooks/useApi";
import LoadMask from 'Utils/LoadMask/LoadMask';
import { convertDataCurrency } from "../Utils/Utils";
import { ReporContextProvider } from "../Context/ReportContext";

const defaultValues = {
    ComparativoCostoMP: {
        SolidosData: { ...SolidosDataCostoMP },
        LatexData: { ...LatexDataCostoMP },
        SKIMData: { ...SKIMDataCostoMP }
    },
    ComparativoCostoVentas: {
        SolidosData: { ...SolidosDataCostoVentas },
        LatexProcesoData: { ...LatexProcesoData },
        SKIMData: { ...SKIMDataCostoVentas }
    },
};

export default function ComparativoMPVentasReport() {
    const [tab, setTab] = useState("COSTO_MP");

    // _____________ FORM _____________
    const methods = useForm({
        defaultValues: defaultValues
    });


    // _____________ API _____________
    const { guardarReporte, getReporte, loading, dollarExchange } = useApi();

    const GuardarReporte = () => {
        const payload = { ...methods.getValues(), isDollar: currency === '$' };
        guardarReporte(payload, setResponseData);
    }

    const GetData = () => {
        getReporte(setResponseData);
    }

    const setResponseData = (response) => {
        setCurrency('$');
        if (!response) {
            methods.reset(defaultValues);
            return;
        } else if (Object.keys(response).length === 0) {
            methods.reset(defaultValues);
            return;
        }
        methods.reset(response);
    }

    useEffect(() => {
        GetData();
    }, []);

    // _____________ CURRENCY _____________
    const [currency, setCurrency] = useState('$');

    const handleCurrencyChange = (e) => {
        setCurrency(e.target.value);

        const dataForm = methods.getValues();
        const dataConverted = convertDataCurrency(dataForm, e.target.value, dollarExchange);
        methods.reset(dataConverted);
    }

    return (
        <div >
            <LoadMask loading={loading} blur>
                <ReporContextProvider currency={currency} setCurrency={setCurrency}>
                    <div className=" report__currency-select">
                        <label htmlFor="currency-selector" >Expresado en:</label>
                        <select id="currency-selector" className="form-control custom-select"
                            style={{ border: 'none', outline: 'none', boxShadow: 'none' }}
                            value={currency} onChange={handleCurrencyChange}
                        >
                            <option value="$">Dólar US$</option>
                            <option value="Q">Quetzales (GTQ)</option>
                        </select>
                    </div>
                    <FormProvider {...methods}>
                        <Tabs
                            defaultActiveKey={tab}
                            activeKey={tab}
                            onChange={tab => setTab(tab)}
                            animated={{ tabPane: true, inkBar: true }}
                            destroyInactiveTabPane={true}
                            moreIcon={<span className='icon-more-icon'>+</span>}
                        >
                            <TabPane tab="COMPARATIVO COSTO MP" key="COSTO_MP">
                                <CardEmpty noShadow isMarginButtom>
                                    <ComparativoCostoMP />
                                </CardEmpty>
                            </TabPane>
                            <TabPane tab="COMPARATIVO COSTO DE VENTAS" key="COSTO_VENTAS">
                                <CardEmpty noShadow isMarginButtom>
                                    <ComparativoCostoVentas />
                                </CardEmpty>
                            </TabPane>
                        </Tabs>

                        <div className='buttons-box mt-3'>
                            <button type="button" className="btn btn-primary m-4 btn-modal"
                                onClick={GuardarReporte}>
                                CONFIRMAR
                            </button>
                        </div>
                    </FormProvider>
                </ReporContextProvider>
            </LoadMask>
        </div>
    );
}
